import script from "./EventsItemMemberAdder.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsItemMemberAdder.vue?vue&type=script&setup=true&lang=ts"

import "./EventsItemMemberAdder.vue?vue&type=style&index=0&id=94286936&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94286936"]])

export default __exports__